<flat-header
  *ngIf="configurationService.isTabletOrLarger$ | async"
  headerText="cartModule.cart"
></flat-header>

<!-- Content Section -->
<div class="container-lg main-container bg-lg-transparent shadow-none">
  <div class="row">
    <div class="col-12 col-md-8 mb-sm-3 p-0 p-md-3">
      <section class="card">
        <div class="card-body">
          <div
            class="spinner-border"
            role="status"
            *ngIf="isLoading$ | async"
            attr.aria-label="{{ 'wcag.loading' | translate }}"
          ></div>

          <div
            *ngIf="
              !(cartItems$ | async)?.length &&
              (cartItemUnauthenticatedCount$ | async) == 0 &&
              !(isLoading$ | async)
            "
            class="text-center py-5"
          >
            <img
              class="img-fluid mb-3"
              style="max-width: 6rem"
              src="assets/svg/illustrations/empty-cart.svg"
              alt="{{ 'cartModule.yourCartIsEmpty' | translate }}"
            />

            <h3 class="text-center" data-test-id="checkout-text-cart-empty">
              {{ 'cartModule.yourCartIsEmpty' | translate }}
            </h3>
          </div>
          <div *ngIf="(cartItems$ | async)?.length && !(isLoading$ | async)">
            <div
              *ngIf="configurationService.isTabletOrLarger$ | async"
              class="border-bottom pb-3 mb-3"
              data-test-id="cart-items-loaded"
            >
              <div class="row fw-bold text-uppercase">
                <div class="col-5 d-none d-lg-block col-lg-6">
                  {{ 'general.description' | translate }}
                </div>
                <div class="col-8 col-lg-3 col-xl-4">
                  {{ 'shopModule.price' | translate }} /
                  {{ 'shopModule.quantity' | translate }}
                </div>
                <div class="col-4 col-lg">
                  {{ 'shopModule.total' | translate }}
                </div>
              </div>
            </div>
            <div data-test-id="cart-items-cards-loaded">
              <ng-container
                *ngFor="let cartItem of cartItems$ | async; let index = index"
              >
                <div
                  class="border-bottom pb-3 mb-3"
                  data-test-id="cart-item-loaded"
                >
                  <div class="row">
                    <div class="col-12 col-lg-6 col-xl-6">
                      <div class="row">
                        <div
                          class="col"
                          *ngIf="
                            (cartItem.productId ||
                              cartItem.params?.bookableLinkedProductId) &&
                            !cartItem.courseId
                          "
                        >
                          <div
                            *ngIf="
                              cartItem.type == 'product' ||
                              cartItem.type == 'rental'
                            "
                          >
                            <div class="mb-2">
                              <strong
                                data-test-id="cart-item-linkedProduct-translation"
                                >{{
                                  (cartItem.params?.bookableLinkedProductId
                                    ? cartItem.params?.bookableLinkedProductId
                                    : cartItem.productId
                                  )
                                    | getTranslation: 'product' : 'description'
                                    | async
                                }}</strong
                              >
                            </div>
                            <small
                              data-test-id="cart-item-details-product"
                              [innerHTML]="
                                cartItemService.getCartItemDetail(cartItem)
                                  | async
                              "
                            ></small>
                          </div>
                          <div *ngIf="cartItem.type == 'ticket'">
                            <div class="mb-2">
                              <strong
                                data-test-id="cart-item-linkedProduct-translation"
                              >
                                {{
                                  (cartItem.params?.bookableLinkedProductId
                                    ? cartItem.params?.bookableLinkedProductId
                                    : cartItem.productId
                                  )
                                    | getTranslation: 'product' : 'description'
                                    | async
                                }}</strong
                              >
                            </div>
                            <small
                              data-test-id="cart-item-details-product"
                              [innerHTML]="
                                cartItemService.getCartItemDetail(cartItem)
                                  | async
                              "
                            ></small>
                          </div>
                        </div>

                        <div class="col" *ngIf="cartItem.subscriptionId">
                          <div class="mb-2">
                            <strong>{{
                              cartItem.subscriptionId
                                | getTranslation: 'subscription' : 'description'
                                | async
                            }}</strong>
                          </div>
                          <small
                            [innerHTML]="
                              cartItemService.getCartItemDetail(cartItem)
                                | async
                            "
                          ></small>
                        </div>

                        <div class="col" *ngIf="cartItem.courseId">
                          <div class="mb-2">
                            <strong>{{
                              cartItem.productId
                                | getTranslation: 'product' : 'description'
                                | async
                            }}</strong>
                          </div>
                          <small
                            [innerHTML]="
                              cartItemService.getCartItemDetail(cartItem)
                                | async
                            "
                          ></small>
                        </div>
                        <div class="col-auto">
                          <button
                            type="button"
                            class="btn btn-ghost-primary"
                            (click)="onRemove(cartItem)"
                            [attr.data-test-id]="'checkout-item-remove-button'"
                          >
                            <i
                              class="far fa-trash-alt"
                              role="img"
                              attr.aria-label="{{ 'wcag.remove' | translate }}"
                            ></i>
                            <span class="visually-hidden">
                              <ng-container
                                *ngIf="
                                  cartItem.type == 'product' ||
                                  cartItem.type == 'rental'
                                "
                              >
                                {{
                                  (cartItem.params?.bookableLinkedProductId
                                    ? cartItem.params?.bookableLinkedProductId
                                    : cartItem.productId
                                  )
                                    | getTranslation: 'product' : 'description'
                                    | async
                                }}
                              </ng-container>

                              <ng-container *ngIf="cartItem.type == 'ticket'">
                                {{
                                  (cartItem.params?.bookableLinkedProductId
                                    ? cartItem.params?.bookableLinkedProductId
                                    : cartItem.productId
                                  )
                                    | getTranslation: 'product' : 'description'
                                    | async
                                }}</ng-container
                              >

                              <ng-container *ngIf="cartItem.subscriptionId">
                                {{
                                  cartItem.subscriptionId
                                    | getTranslation
                                      : 'subscription'
                                      : 'description'
                                    | async
                                }}</ng-container
                              >

                              <ng-container *ngIf="cartItem.courseId">
                                {{
                                  cartItem.productId
                                    | getTranslation: 'product' : 'description'
                                    | async
                                }}</ng-container
                              >
                            </span>
                          </button>
                        </div>

                        <div class="col-12">
                          <p
                            *ngIf="(selectedLanguage$ | async) != 'de'"
                            class="small"
                            data-test-id="item-reserved-until-block"
                            >({{
                              'cartModule.expiresAt'
                                | translate
                                | replaceVarInString
                                  : '$EXPIRATION_TIME$'
                                  : (getLimitTimeCartItem(cartItem)
                                      | formatDate: 'd MMM y HH:mm'
                                      | async)
                            }}).
                          </p>
                          <p
                            *ngIf="(selectedLanguage$ | async) == 'de'"
                            class="small"
                            data-test-id="item-reserved-until-block"
                            >({{
                              'cartModule.expiresAt'
                                | translate
                                | replaceVarInString
                                  : '$EXPIRATION_TIME$'
                                  : (getLimitTimeCartItem(cartItem)
                                      | date: 'HH:mm')
                            }}).
                          </p>
                        </div>

                        <div
                          *ngIf="
                            (familyMemberService.isFamilyFeatureEnabled()
                              | async) &&
                            cartItem?.params?.familyMembersInvited?.length > 0
                          "
                          data-test-id="family-invite-block"
                        >
                          <span
                            >{{
                              'cartModule.invitedFamilyMembers' | translate
                            }}:</span
                          >

                          <div
                            *ngFor="
                              let personId of cartItem?.params
                                ?.familyMembersInvited
                            "
                            class="family-member-item"
                          >
                            <div
                              class="family-member-name"
                              data-test-id="family-member-name"
                            >
                              {{
                                familyMemberService.getInvitedFamilyMemberName(
                                  personId
                                ) | async
                              }}

                              <span
                                class="mb-2"
                                *ngIf="
                                  getPrice(
                                    productEntities$ | async,
                                    cartItem.params?.bookableLinkedProductId
                                      ? cartItem.params?.bookableLinkedProductId
                                      : cartItem.productId,
                                    cartItem,

                                    cartItemService.getCartItemPrice$(
                                      cartItem,
                                      'myPrice',
                                      personId
                                    ) | async,
                                    'myPrice'
                                  ).price > 0
                                "
                                data-test-id="family-member-price"
                              >
                                <span
                                  *ngIf="cartItem.courseId && cartItem.params"
                                >
                                  {{
                                    cartItemService.getCartItemPrice$(
                                      cartItem,
                                      'myPrice',
                                      personId
                                    )
                                      | async
                                      | currency
                                  }}
                                </span>
                                <span
                                  *ngIf="
                                    !(cartItem.courseId && cartItem.params) &&
                                    !(productEntities$ | async)[
                                      cartItem.params?.bookableLinkedProductId
                                        ? cartItem.params
                                            ?.bookableLinkedProductId
                                        : cartItem.productId
                                    ]?.allowChooseCategory
                                  "
                                  data-test-id="family-member-price"
                                >
                                  {{
                                    getPrice(
                                      productEntities$ | async,
                                      cartItem.params?.bookableLinkedProductId
                                        ? cartItem.params
                                            ?.bookableLinkedProductId
                                        : cartItem.productId,
                                      cartItem,
                                      cartItemService.getCartItemPrice$(
                                        cartItem,
                                        'myPrice',
                                        personId
                                      ) | async,
                                      'myPrice'
                                    ).price | currency
                                  }}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      *ngIf="!!cartItem.params?.bookableProductId"
                      class="col-8 col-lg-3 col-xl-4"
                    >
                      <!-- * MY PRICE -->
                      <p
                        class="mb-2"
                        *ngIf="
                          !(
                            cartItem?.params?.familyMembersInvited?.length >
                              0 && cartItem?.params?.bookerAssisting === false
                          ) &&
                          (getPrice(
                            productEntities$ | async,
                            cartItem.params?.bookableLinkedProductId
                              ? cartItem.params?.bookableLinkedProductId
                              : cartItem.productId,
                            cartItem,
                            cartItemService.getCartItemPrice$(
                              cartItem,
                              'myPrice'
                            ) | async,
                            'myPrice'
                          ).price > 0 ||
                            (cartItem?.params?.familyMembersInvited?.length >
                              0 &&
                              (cartItem?.params?.bookerAssisting ?? true)))
                        "
                      >
                        <span *ngIf="cartItem.courseId && cartItem.params">
                          {{
                            cartItemService.getCartItemPrice$(
                              cartItem,
                              'myPrice'
                            )
                              | async
                              | currency
                          }}
                          × {{ cartItem?.amount }} ({{
                            'shopModule.myPrice' | translate
                          }})
                        </span>
                        <span
                          *ngIf="
                            !(cartItem.courseId && cartItem.params) &&
                            !(productEntities$ | async)[
                              cartItem.params?.bookableLinkedProductId
                                ? cartItem.params?.bookableLinkedProductId
                                : cartItem.productId
                            ]?.allowChooseCategory
                          "
                        >
                          {{
                            getPrice(
                              productEntities$ | async,
                              cartItem.params?.bookableLinkedProductId
                                ? cartItem.params?.bookableLinkedProductId
                                : cartItem.productId,
                              cartItem,
                              cartItemService.getCartItemPrice$(
                                cartItem,
                                'myPrice'
                              ) | async,
                              'myPrice'
                            ).price | currency
                          }}
                          × {{ cartItem?.amount }} ({{
                            'shopModule.myPrice' | translate
                          }})
                        </span>
                      </p>
                      <ng-container
                        *ngIf="
                          cartItem?.params?.familyMembersInvited?.length > 0
                        "
                      >
                        <p
                          class="mb-2"
                          *ngFor="
                            let personId of cartItem?.params
                              ?.familyMembersInvited
                          "
                        >
                          {{
                            cartItemService.getCartItemPrice$(
                              cartItem,
                              'myPrice',
                              personId
                            )
                              | async
                              | currency
                          }}
                          × 1 ({{
                            familyMemberService.getInvitedFamilyMemberName(
                              personId
                            ) | async
                          }})
                        </p>
                      </ng-container>
                      <!-- * GUESTS PRICE -->
                      <p
                        class="mb-2"
                        *ngIf="cartItem?.params?.invitedGuests?.length > 0"
                        data-test-id="price-guest-invited"
                      >
                        {{ getPriceOfGuestInvite(cartItem) | currency }}
                        ×
                        {{ cartItem?.params?.invitedGuests?.length }}
                        <span *ngIf="!getInvitedGuestCategory(cartItem)">
                          ({{ 'productModule.guests' | translate }})
                        </span>
                        <span
                          *ngIf="
                            getInvitedGuestCategory(cartItem) as guestCategory
                          "
                          data-test-id="cart-item-category-description"
                        >
                          ({{
                            guestCategory
                              | customerCategoryName
                                : (productEntities$ | async)[
                                    cartItem.params?.bookableLinkedProductId
                                      ? cartItem.params?.bookableLinkedProductId
                                      : cartItem.productId
                                  ]?.siteId
                              | async
                          }}
                          )</span
                        >
                      </p>
                      <!-- * MEMBERS PRICE -->
                      <p
                        class="mb-2"
                        *ngIf="
                          cartItem?.params?.invitedMemberEmails?.length > 0
                        "
                        [attr.data-test-id]="
                          'cart-item-booking-member-price-' +
                          cartItem.productId
                        "
                      >
                        {{
                          (productEntities$ | async)[
                            cartItem.params?.bookableLinkedProductId
                              ? cartItem.params?.bookableLinkedProductId
                              : cartItem.productId
                          ]?.linkedSubsPrice !== undefined && 0 | currency
                        }}
                        ×
                        {{ cartItem?.params?.invitedMemberEmails?.length }} ({{
                          'memberModule.members' | translate
                        }})
                      </p>
                      <!-- * CHAPERONES PRICE -->
                      <p
                        class="mb-2"
                        *ngIf="cartItem?.params?.invitedOthers?.length > 0"
                        [attr.data-test-id]="
                          'cart-item-booking-other-price-' + cartItem.productId
                        "
                      >
                        {{
                          getOtherInvitePrice(
                            productEntities$ | async,
                            cartItem
                          ) | currency
                        }}
                        × {{ cartItem?.params?.invitedOthers?.length }} ({{
                          'productModule.chaperones' | translate
                        }})
                      </p>
                      <!-- * BASE PRICE -->
                      <p
                        class="mb-2"
                        *ngIf="getCartItemBasePrice(cartItem) as basePrice"
                      >
                        {{ 'productModule.basePrice' | translate }}
                        {{ basePrice | currency }}
                      </p>
                    </div>
                    <div
                      *ngIf="!cartItem.params?.bookableProductId"
                      class="col-8 col-lg-3 col-xl-4"
                    >
                      <p
                        [attr.data-test-id]="
                          'cart-item-price-quantity-' + cartItem.productId
                        "
                        [attr.data-test-cart-item-quantity-key]="
                          cartItem.productId
                            ? 'product-' + cartItem.productId
                            : cartItem.subscriptionId
                              ? 'subscription-' + cartItem.subscriptionId
                              : cartItem.courseId
                                ? 'course-' + cartItem.courseId
                                : null
                        "
                      >
                        <span *ngIf="!cartItem.subscriptionId">
                          {{
                            cartItemService.getCartItemPrice$(cartItem)
                              | async
                              | currency
                          }}
                          ×
                        </span>
                        {{ cartItem.amount }} ({{
                          getCartItemQuantityLabel$(
                            cartItem,
                            productEntities$ | async
                          ) | async
                        }})
                      </p>
                    </div>
                    <div class="col-4 col-lg">
                      {{
                        ((cartItemService.getCartItemTotal$(cartItem, false)
                          | async) ?? 0) + getCartItemBasePrice(cartItem)
                          | currency
                      }}
                      <div
                        *ngIf="
                          cartItem.subscriptionId &&
                          (subscriptionEntities$ | async)?.[
                            cartItem.subscriptionId
                          ]?.adminFee
                        "
                        class="small text-muted"
                      >
                        +
                        {{
                          (subscriptionEntities$ | async)?.[
                            cartItem.subscriptionId
                          ]?.adminFee | currency
                        }}
                        {{
                          (adminFeeProductId$
                            | async
                            | getTranslation: 'product' : 'description'
                            | async) ||
                            ('subscriptionModule.adminFee' | translate)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="row">
              <div class="col-8 col-lg-9 col-xl-10">
                <span class="h5">{{ 'general.total' | translate }}</span>
              </div>

              <div class="col-4 col-lg-2">
                <span data-test-id="cart-show-page-total" class="h5">{{
                  cartItemsTotal$ | async | currency
                }}</span>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              (cartItemUnauthenticatedCount$ | async) > 0 &&
              !(isLoading$ | async)
            "
          >
            <div class="border-bottom pb-3 mb-3">
              <div class="row fw-bold text-uppercase">
                <div class="col-5 d-none d-lg-block col-lg-6">
                  {{ 'general.description' | translate }}
                </div>
                <div class="col-8 col-lg-3 col-xl-4">
                  {{ 'shopModule.price' | translate }} /
                  {{ 'shopModule.quantity' | translate }}
                </div>
                <div class="col-4 col-lg">
                  {{ 'shopModule.total' | translate }}
                </div>
              </div>
            </div>
            <ng-container
              *ngFor="
                let cartItem of cartItemsUnauthenticated$ | async;
                let index = index
              "
            >
              <div class="border-bottom pb-3 mb-3">
                <div class="row">
                  <div class="col-12 col-lg-6 col-xl-6">
                    <div
                      class="row flex-nowrap flex-row-reverse align-items-start justify-content-between mb-3"
                    >
                      <div class="col-auto">
                        <button
                          type="button"
                          class="btn btn-ghost-primary"
                          (click)="onRemoveUnauthenticated(cartItem)"
                          [attr.data-test-id]="'checkout-item-remove-button'"
                        >
                          <i
                            class="far fa-trash-alt"
                            role="img"
                            attr.aria-label="{{ 'wcag.remove' | translate }}"
                          ></i>
                        </button>
                      </div>

                      <div
                        class="col"
                        *ngIf="
                          cartItem.productId ||
                          cartItem?.params?.bookableLinkedProductId
                        "
                      >
                        <p class="mb-2">
                          <strong>{{
                            (cartItem.params?.bookableLinkedProductId
                              ? cartItem.params?.bookableLinkedProductId
                              : cartItem.productId
                            )
                              | getTranslation: 'product' : 'description'
                              | async
                          }}</strong>
                        </p>
                        <small
                          [innerHTML]="
                            cartItemService.getCartItemDetail(cartItem) | async
                          "
                        ></small>
                      </div>

                      <div class="col" *ngIf="cartItem.subscriptionId">
                        <p class="mb-2">
                          <strong>{{
                            cartItem.subscriptionId
                              | getTranslation: 'subscription' : 'description'
                              | async
                          }}</strong>
                        </p>
                        <small
                          [innerHTML]="
                            cartItemService.getCartItemDetail(cartItem) | async
                          "
                        ></small>
                      </div>

                      <div class="col" *ngIf="cartItem.courseId">
                        <p class="mb-2">
                          <strong>{{
                            cartItem.productId
                              | getTranslation: 'product' : 'description'
                              | async
                          }}</strong>
                        </p>
                        <small
                          [innerHTML]="
                            cartItemService.getCartItemDetail(cartItem) | async
                          "
                        ></small>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="!!cartItem.params?.bookableProductId"
                    class="col-8 col-lg-3 col-xl-4"
                  >
                    <p
                      *ngIf="
                        !(
                          cartItem?.params?.familyMembersInvited?.length > 0 &&
                          cartItem?.params?.bookerAssisting === false
                        ) &&
                        getPrice(
                          productEntities$ | async,
                          cartItem.params?.bookableLinkedProductId
                            ? cartItem.params?.bookableLinkedProductId
                            : cartItem.productId,
                          cartItem,
                          cartItemService.getCartItemPrice$(cartItem) | async,
                          'myPrice'
                        ).price > 0
                      "
                    >
                      {{
                        getPrice(
                          productEntities$ | async,
                          cartItem.params?.bookableLinkedProductId
                            ? cartItem.params?.bookableLinkedProductId
                            : cartItem.productId,
                          cartItem,
                          cartItemService.getCartItemPrice$(cartItem, 'myPrice')
                            | async,
                          'myPrice'
                        ).price | currency
                      }}
                      × {{ cartItem?.amount }} ({{
                        'shopModule.myPrice' | translate
                      }})
                    </p>
                    <ng-container
                      *ngIf="cartItem?.params?.familyMembersInvited?.length > 0"
                    >
                      <p
                        *ngFor="
                          let personId of cartItem?.params?.familyMembersInvited
                        "
                      >
                        {{
                          cartItemService.getCartItemPrice$(
                            cartItem,
                            'myPrice',
                            personId
                          )
                            | async
                            | currency
                        }}
                        × 1 ({{
                          familyMemberService.getInvitedFamilyMemberName(
                            personId
                          ) | async
                        }})
                      </p>
                    </ng-container>
                    <p *ngIf="cartItem?.params?.invitedGuests?.length > 0">
                      {{
                        (productEntities$ | async)[
                          cartItem.params?.bookableLinkedProductId
                            ? cartItem.params?.bookableLinkedProductId
                            : cartItem.productId
                        ]?.guestPrice | currency
                      }}
                      × {{ cartItem?.params?.invitedGuests?.length }} ({{
                        'productModule.guests' | translate
                      }})
                    </p>
                    <p
                      *ngIf="cartItem?.params?.invitedMemberEmails?.length > 0"
                    >
                      {{
                        (productEntities$ | async)[
                          cartItem.params?.bookableLinkedProductId
                            ? cartItem.params?.bookableLinkedProductId
                            : cartItem.productId
                        ]?.linkedSubsPrice !== undefined && 0 | currency
                      }}
                      × {{ cartItem?.params?.invitedMemberEmails?.length }} ({{
                        'memberModule.members' | translate
                      }})
                    </p>
                    <p *ngIf="cartItem?.params?.invitedOthers?.length > 0">
                      {{
                        ((productEntities$ | async)[
                          cartItem.params?.bookableLinkedProductId
                            ? cartItem.params?.bookableLinkedProductId
                            : cartItem.productId
                        ]?.otherInvitePrice
                          ? (productEntities$ | async)[
                              cartItem.params?.bookableLinkedProductId
                                ? cartItem.params?.bookableLinkedProductId
                                : cartItem.productId
                            ]?.otherInvitePrice
                          : 0
                        ) | currency
                      }}
                      × {{ cartItem?.params?.invitedOthers?.length }} ({{
                        'productModule.chaperones' | translate
                      }})
                    </p>
                  </div>
                  <div
                    *ngIf="!cartItem.params?.bookableProductId"
                    class="col-8 col-lg-3 col-xl-4"
                  >
                    <p
                      [attr.data-test-id]="
                        'cart-item-price-quantity-' + cartItem.productId
                      "
                      [attr.data-test-cart-item-quantity-key]="
                        cartItem.productId
                          ? 'product-' + cartItem.productId
                          : cartItem.subscriptionId
                            ? 'subscription-' + cartItem.subscriptionId
                            : cartItem.courseId
                              ? 'course-' + cartItem.courseId
                              : null
                      "
                    >
                      {{
                        cartItemService.getCartItemPrice$(cartItem)
                          | async
                          | currency
                      }}
                      × {{ cartItem.amount }} ({{
                        'shopModule.quantity' | translate
                      }})
                    </p>
                  </div>
                  <div class="col-4 col-lg">
                    {{
                      cartItem.amount *
                        (cartItemService.getCartItemPrice$(cartItem, 'total')
                          | async) | currency
                    }}
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="row">
              <div class="col-8 col-lg-9 col-xl-10 h4">
                {{ 'general.total' | translate }}
              </div>

              <div class="col-4 col-lg-2 h4">
                <span *ngIf="cartItemsTotal$ | async">{{
                  cartItemsTotal$ | async | currency
                }}</span>
                <span *ngIf="(cartItemUnauthenticatedCount$ | async) > 0">
                  {{
                    cartItemService.getUnauthenticatedCartItemTotal$()
                      | async
                      | currency
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="col-12 col-md-4 mb-sm-3 p-0 p-md-3">
      <section class="card">
        <div class="card-body">
          <div class="mb-1 row g-2 row-cols-2" *ngIf="!(isLoading$ | async)">
            <div class="col" *ngIf="member$ | async">
              <button
                type="button"
                [disabled]="(cartItemCount$ | async) == 0"
                class="btn btn-sm btn-white d-flex align-items-center flex-column justify-content-between h-100 w-100"
                (click)="onEmptyCartClick()"
                data-test-id="empty-cart-button"
              >
                <i class="fas fa-trash my-1" aria-hidden="true" role="img"></i>
                {{ 'cartModule.emptyCart' | translate }}
              </button>
            </div>
            <div class="col" *ngIf="!(member$ | async)">
              <button
                type="button"
                class="btn btn-sm btn-white d-flex align-items-center flex-column justify-content-between h-100 w-100"
                (click)="onEmptyCartClickUnauthenticated()"
                data-test-id="empty-cart-button"
              >
                <i class="fas fa-trash my-1" aria-hidden="true" role="img"></i>
                {{ 'cartModule.emptyCart' | translate }}
              </button>
            </div>

            <div class="col">
              <button
                *ngIf="bookingModuleConfig?.isActive"
                [routerLink]="getLandingPageRedirect()"
                type="button"
                class="btn btn-sm btn-white d-flex align-items-center flex-column justify-content-between h-100 w-100"
              >
                <i
                  class="fas fa-calendar my-1"
                  aria-hidden="true"
                  role="img"
                ></i>
                {{ 'cartModule.goToSchedule' | translate }}
              </button>
            </div>
            <div class="col" *ngIf="shopModuleConfig.isActive">
              <button
                (click)="backToShopping()"
                type="button"
                class="btn btn-sm btn-white d-flex align-items-center flex-column justify-content-between h-100 w-100"
              >
                <i
                  class="fas fa-cart-plus my-1"
                  aria-hidden="true"
                  role="img"
                ></i>
                {{ 'shopModule.continueShopping' | translate }}
              </button>
            </div>
            <div
              class="col"
              *ngIf="!(configurationService.isMobileApp$ | async)"
            >
              <button
                type="button"
                class="btn btn-sm btn-white d-flex align-items-center flex-column justify-content-between h-100 w-100"
                (click)="printScreen()"
              >
                <i class="fas fa-print my-1" aria-hidden="true" role="img"></i>
                {{ 'cartModule.print' | translate }}
              </button>
            </div>
          </div>

          <div
            class="my-md-3"
            *ngIf="
              organizationModuleConfig.isActive &&
              (
                userRoleHelperService.getUserRoles$([RolesType.CUSTOMER])
                | async
              )?.length > 1
            "
          >
            <ng-container *ngIf="(userRoles$ | async)?.length > 1">
              <hr class="d-md-none" />
              <h2 class="h4">
                {{ 'organizationModule.organization' | translate }}
              </h2>
              <div class="row">
                <div class="col-12 col-lg-9 mb-2">
                  {{ 'paymentModule.selectPurchaseUserRole' | translate }}
                </div>
                <div class="col-3 d-none d-lg-block">
                  <figure class="max-w-10rem mx-auto">
                    <img
                      class="img-fluid"
                      src="../assets/svg/illustrations/buildings.svg"
                      alt="{{ 'wcag.organization' }}"
                      aria-hidden="true"
                    />
                  </figure>
                </div>
              </div>
              <user-role-switcher
                [showAlertOnPrivateUserRoleSelected]="true"
                [showLabel]="true"
              ></user-role-switcher>
            </ng-container>
          </div>
          <form [formGroup]="form" *ngIf="isOrderNumberEnable">
            <label id="orderNumberId" class="form-label">
              {{ 'saleModule.orderNumber' | translate }}:
            </label>
            <input
              aria-labelledby="orderNumberId"
              aria-describedby="orderNumber"
              class="form-control"
              type="text"
              inputmode="text"
              formControlName="orderNumber"
              [attr.aria-invalid]="
                form.controls.orderNumber.dirty &&
                form.controls.orderNumber.invalid
                  ? 'true'
                  : null
              "
            />
            <p
              class="invalid-feedback"
              aria-atomic="true"
              id="orderNumber"
              role="alert"
              *ngIf="
                form.controls.orderNumber.dirty &&
                form.controls.orderNumber.invalid
              "
            >
              {{ 'saleModule.orderNumber' | translate }}
              {{ 'general.isInvalid' | translate }}
            </p>
          </form>

          <div class="fixed-mobile mt-2">
            <button
              *ngIf="(cartItemCount$ | async) > 0"
              type="button"
              class="btn btn-primary d-block w-100"
              (click)="onClickCreateSale()"
              data-test-id="confirm-cart-button"
              [disabled]="confirmButtonIsDisabled"
            >
              {{ 'cartModule.confirmOrder' | translate }}
            </button>
            <button
              *ngIf="
                !(member$ | async) &&
                (cartItemUnauthenticatedCount$ | async) > 0
              "
              type="button"
              class="btn btn-primary d-block w-100"
              (click)="goToLogin()"
              data-test-id="confirm-cart-button"
              [disabled]="confirmButtonIsDisabled"
            >
              {{ 'cartModule.confirmOrder' | translate }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
